/* Internal imports */
import CITRA from '../../../../../api/citra';
import { TYPE_DOCUMENT } from '../../../../../common/Configuration';
import { isUploadListeRatificationEnabled } from '../../../../../services/TenantService';
import {
  DOCUMENTS_EPARGNE_OPT_ASSOC_DECLARE,
  DOCUMENTS_EPARGNE_OPT_ASSOC_UTILITE_PUBLIQUE,
  DOCUMENTS_EPARGNE_OPT_PROFESSION_LIBERALE,
  DOCUMENTS_EPARGNE_OPT_SOCIETES,
  DOCUMENTS_EPARGNE_REQ_ASSOC_DECLARE,
  DOCUMENTS_EPARGNE_REQ_ASSOC_UTILITE_PUBLIQUE,
  DOCUMENTS_EPARGNE_REQ_PROFESSION_LIBERALE,
  DOCUMENTS_EPARGNE_REQ_SOCIETES,
  FILESKEYS,
  FORMES_JURIDIQUES
} from '../../../../constantes/US/FINALISATION_FORM';

/* Third-party imports */
import axios from 'axios';
import ExcelJS from 'exceljs';

const getFileMetadata = (file, documentType) => ({
    name: file.name,
    mimetype: file.type,
    size: file.size,
    documentType
});

const getDirectorIdentityFiles = (justificatifIdentite) => {
  const identityFiles = [
    {
      file: null,
      networkError: false,
      networkErrorMessage: null,
      isLoading: false
    },{
      file: null,
      networkError: false,
      networkErrorMessage: null,
      isLoading: false
    }
  ];

  if(!justificatifIdentite || justificatifIdentite.length == 0) {
    return identityFiles;
  }

  if(justificatifIdentite && justificatifIdentite.length) {
    for(let i = 0 ; i < justificatifIdentite.length ; i++) {
      identityFiles[i].file = { name: justificatifIdentite[i] };
    }
  }

  return identityFiles;
};

const getFile = (file) => {
  return [
    {
      file: file?.length > 0 ? { name: file[0] } : null,
      networkError: false,
      networkErrorMessage: null,
      isLoading: false
    }
  ];
};

const getMultipleFilesData = (filesName) => {
  const multipleFiles = [];

  if (!filesName || filesName.length == 0) {
    multipleFiles.push({
      file: null,
      networkError: false,
      networkErrorMessage: null,
      isLoading: false
    });
    return multipleFiles;
  }

  for (let i = 0, filesNameLength = filesName.length; i < filesNameLength; i++) {
    multipleFiles.push({
      file: { name: filesName[i] },
      networkError: false,
      networkErrorMessage: null,
      isLoading: false
    });
  }

  return multipleFiles;
};

const filterDocuments = function(planExistant, annexeKyc, formeJuridique) {
  let { required: requiredDocuments, optional: optionalDocuments } = getDocumentsByLegalStatusType(formeJuridique);

  //Si pas de plan place, un supprime la partie plan existant de l'upload des pièces annexes
  if (!planExistant.accordInteressementEnPlace) {
    requiredDocuments = requiredDocuments.filter((document) => document.type !== TYPE_DOCUMENT.ACCORD_INTERESSEMENT);
  }
  if (!planExistant.accordParticipationEnPlace) {
    requiredDocuments = requiredDocuments.filter((document) => document.type !== TYPE_DOCUMENT.ACCORD_PARTICIPATION);
  }
  if (!planExistant.accordPPVEnPlace) {
    requiredDocuments = requiredDocuments.filter((document) => document.type !== TYPE_DOCUMENT.ACCORD_PPV);
  }

  if(Array.isArray(annexeKyc?.actionnaires)) {
    const nbActionnairesPhysiques = annexeKyc.actionnaires.filter((actionnaire) => !actionnaire.beneficiaireIsPersonneMorale).length;

    //Si pas d'actionnaires physiques, pas besoin de demander l'upload de pièces d'identités pour KYC
    if(nbActionnairesPhysiques === 0) {
      requiredDocuments = requiredDocuments.filter((document) => document.type !== TYPE_DOCUMENT.ANNEXE_KYC_PERSON);
    }
    //Si pas d'actionnaires moraux, pas besoin de demander l'upload de KBis pour KYC
    if(annexeKyc?.actionnaires.length - nbActionnairesPhysiques === 0) {
      requiredDocuments = requiredDocuments.filter((document) => document.type !== TYPE_DOCUMENT.ANNEXE_KYC_ENTITY);
    }
  }

  //TODO: supprimer ce if si ajout de la PJ ou changer variable d'env à TRUE
  if (!isUploadListeRatificationEnabled()) {
    requiredDocuments = requiredDocuments.filter((document) => document.type !== TYPE_DOCUMENT.CONSULTATION_ENTREPRISE);
  }

  return {
    required: requiredDocuments,
    optional: optionalDocuments
  };
};

const sendFolder = function (url) {
  return CITRA().post(url);
};

const setCurrentFile = (files, setFiles, index, key, isLoading, networkError, networkErrorMessage) => {
  files[key][index] = {
    ...files[key][index],
    isLoading,
    networkErrorMessage,
    networkError
  };

  setFiles({
    ...files,
    [key]: files[key]
  });
};

const getUploadFileUrl = function (url, fileMetadata, folderId) {
  return CITRA().post(`${url}?name=${encodeURIComponent(folderId)}`, fileMetadata);
};

const uploadFileToS3 = function(url, file, fileMetadata) {
  return axios.create({
    headers: {
      'Content-Type': file.type,
      'Content-Disposition': `attachment; filename="${fileMetadata.name}"`
    }
  }).put(url, file);
}

const sendNotification = function(url, fileMetadata, folderId) {
  return CITRA().put(`${url}?name=${encodeURIComponent(folderId)}`, fileMetadata);
}

const getUpdatedEntity = function(url, uid) {
  return CITRA().get(`${url}?name=${encodeURIComponent(uid)}`);
}

const deleteFile = function(url, fileMetadata, folderId) {
  return CITRA().delete(`${url}?name=${encodeURIComponent(folderId)}`, {
    data: fileMetadata
  });
};

/**
 * Retourne la liste des documents associés à la forme juridique de l'entreprise souscriptrice
 * @param legalStatus {String}
 */
const getDocumentsByLegalStatusType = (legalStatus) => {
  switch (legalStatus) {
    case FORMES_JURIDIQUES.ASSOCIATION_DECLARE.key:
      return {
        required: DOCUMENTS_EPARGNE_REQ_ASSOC_DECLARE,
        optional: DOCUMENTS_EPARGNE_OPT_ASSOC_DECLARE
      }
    case FORMES_JURIDIQUES.ASSOCIATION_UTILITE_PUBLIQUE.key:
      return {
        required: DOCUMENTS_EPARGNE_REQ_ASSOC_UTILITE_PUBLIQUE,
        optional: DOCUMENTS_EPARGNE_OPT_ASSOC_UTILITE_PUBLIQUE
      }
    case FORMES_JURIDIQUES.PROFESSION_LIBERALE.key:
      return {
        required: DOCUMENTS_EPARGNE_REQ_PROFESSION_LIBERALE,
        optional: DOCUMENTS_EPARGNE_OPT_PROFESSION_LIBERALE
      }
    default:
      return {
        required: DOCUMENTS_EPARGNE_REQ_SOCIETES,
        optional: DOCUMENTS_EPARGNE_OPT_SOCIETES
      }
  }
}

const getFormeJuridiqueByCode = (codeFormeJuridique) => {
  for(const formeJuridique of Object.values(FORMES_JURIDIQUES)) {
    if(formeJuridique.codes && Array.isArray(formeJuridique.codes) && formeJuridique.codes.includes(parseInt(codeFormeJuridique))) {
      return formeJuridique.key;
    }
  }
  return FORMES_JURIDIQUES.SOCIETE.key;
}

const checkMissingRequiredDocuments = (documents, files) => {
  for(const requiredDocument of documents.required) {
    if(!files[requiredDocument.key] || files[requiredDocument.key].find((upload) => (upload.file !== undefined && upload.file !== null)) === undefined) {
      return true;
    }
  }
  return false;
}

const validateBeneficiaryFile = async (file) => {
  // 1. Vérification extension
  if (!file.name.endsWith('.xlsx')) {
    return {
      isValid: false,
      error: "Le fichier doit être au format Excel (.xlsx)"
    };
  }

  try {
    const workbook = new ExcelJS.Workbook();
    const buffer = await file.arrayBuffer();
    await workbook.xlsx.load(buffer);

    const worksheet = workbook.getWorksheet(1);
    if (!worksheet) {
      return {
        isValid: false,
        error: "Le fichier Excel est vide ou illisible."
      };
    }

    // 2. Vérification template (Headers)
    const HEADER_ROW_INDEX = 5; //? Pas fan de ça si ça change un jour faudra le changer
    const EXPECTED_HEADERS = [
      "Statut (Salarié ou TNS)",
      "Civilité",
      "Nom",
      "Prénom",
      "Date de naissance",
      "Adresse postale (personnelle)",
      "Complément d’adresse",
      "Code Postal",
      "Ville",
      "Résident fiscal",
      "N° de téléphone (personnel)",
      "Adresse e-mail (personnelle)",
      "Date d’entrée dans l’entreprise",
      "N° Insee (Numéro de sécurité sociale)"
    ];

    const headerRow = worksheet.getRow(HEADER_ROW_INDEX);
    const extractTextFromCell = (cellValue) => {
      if (!cellValue) return '';

      if (typeof cellValue === 'object' && cellValue.richText && Array.isArray(cellValue.richText)) {
        return cellValue.richText.map((part) => part.text).join('');
      }

      return cellValue.toString();
    };
    const normalize = (val) => extractTextFromCell(val).replace(/\s/g, '').toLowerCase();

    for (let i = 0; i < EXPECTED_HEADERS.length; i++) {
      const cellValue = headerRow.getCell(i + 1).value;
      if (normalize(cellValue) !== normalize(EXPECTED_HEADERS[i])) {
        return {
          isValid: false,
          error: "Le fichier ne respecte pas le modèle attendu (colonnes incorrectes)."
        };
      }
    }

    // 3. Vérification présence données
    // Objectif : s'assurer qu'il existe AU MOINS 1 bénéficiaire "complet".
    // Les colonnes doivent toutes exister (vérifiées via headers),
    // mais certaines valeurs peuvent être vides et restent acceptées.
    // Champs optionnels métier :
    // - Complément d’adresse
    // - N° de téléphone (personnel)
    // - Adresse e-mail (personnelle)
    const OPTIONAL_DATA_HEADER_INDEXES =[
      7,  // "Complément d’adresse" (1-based)
      11, // "N° de téléphone (personnel)"
      12  // "Adresse e-mail (personnelle)"
    ];

    // On parcourt les lignes après la ligne d'en-têtes et on valide dès qu'on en trouve une complète.
    let hasCompleteBeneficiary = false;
    let firstDataRowMissingRequiredHeaders = null;
    let firstDataRowNumber = null;
    worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
      if (rowNumber <= HEADER_ROW_INDEX) return;
      if (hasCompleteBeneficiary) return;

      const missingRequiredHeaders = [];
      for (let i = 0; i < EXPECTED_HEADERS.length; i++) {
        const columnIndex = i + 1;
        if (OPTIONAL_DATA_HEADER_INDEXES.includes(columnIndex)) continue;

        const cellValue = row.getCell(columnIndex).value;
        const cellText = extractTextFromCell(cellValue);
        if (!cellText || cellText.trim() === '') {
          missingRequiredHeaders.push(EXPECTED_HEADERS[i]);
        }
      }

      if (firstDataRowMissingRequiredHeaders === null) {
        firstDataRowMissingRequiredHeaders = missingRequiredHeaders;
        firstDataRowNumber = rowNumber;
      }

      if (missingRequiredHeaders.length === 0) {
        hasCompleteBeneficiary = true;
      }
    });

    if (!hasCompleteBeneficiary) {
      return {
        isValid: false,
        error: firstDataRowMissingRequiredHeaders && firstDataRowMissingRequiredHeaders.length > 0
          ? `Il doit y avoir au moins un bénéficiaire complet. \nLigne ${firstDataRowNumber}: colonnes obligatoires manquantes: ${firstDataRowMissingRequiredHeaders.join(', ')}.`
          : "Il doit y avoir au moins un bénéficiaire complet."
      };
    }

    return {
      isValid: true,
      error: null
    };

  } catch (error) {
    console.error("Erreur ExcelJS:", error);
    return {
      isValid: false,
      error: "Impossible de lire le fichier Excel."
    };
  }
}


export default {
  FILESKEYS,
  checkMissingRequiredDocuments,
  deleteFile,
  filterDocuments,
  getDirectorIdentityFiles,
  getFile,
  getFileMetadata,
  getFormeJuridiqueByCode,
  getMultipleFilesData,
  getUpdatedEntity,
  sendFolder,
  sendNotification,
  setCurrentFile,
  getUploadFileUrl,
  uploadFileToS3,
  validateBeneficiaryFile
};
